export default "__VITE_ASSET__D$3kOz3A__"